<template>
  <div :key="key" class="dashboard-chart">
    <h4 class="titulo">Mix de Ventas por Cliente</h4>
    <!-- <h4 :class="totalNegocio ? 'titulo' : ''">Mix de Ventas por Cliente</h4>
    <p v-if="totalNegocio" class="subtitulo">Incluye reembolsos</p> -->
    <vue-svg-gauge
      :start-angle="-110"
      :end-angle="110"
      :value="indicadorVentasClientesPjeActual"
      :separator-step="0"
      :min="indicadorVentasClientesMin"
      :max="indicadorVentasClientesMax"
      :gauge-color="indicadorVentasClientesColor"
      :scale-interval="1"/>
    <div class="dashboard-chart-text">
      <p>Pje Objetivo: {{ indicadorVentasClientesPjeObjetivo | numero(2, true) }} %</p>
      <p>Pje Actual: {{ indicadorVentasClientesPjeActual | numero(2, true) }} %</p>
      <p class="description">Monto PG: {{ indicadorVentasClientesPG | moneda }} ({{ indicadorVentasClientesPjePG | porcentaje }})</p>
      <p class="description">Monto Gnm: {{ indicadorVentasClientesGnm | moneda }} ({{ indicadorVentasClientesPjeGnm | porcentaje }})</p>
      <p class="description">Monto Otros: {{ indicadorVentasClientesOtros | moneda }}</p>
      <p class="description">{{ indicadorVentasClientesDescripcion }}</p>
    </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';

export default {
  components: {
    VueSvgGauge,
  },
  props: {
    totalNegocio: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      // indicadorVentasClientesLabels: ['PG', 'Otros'],
      indicadorVentasClientesBackgroundColor: [ '#E46651', '#41B883' ], 
      indicadorVentasClientesData: [],
      indicadorVentasClientesDescripcion: '',
      indicadorVentasClientesPG: 0,
      indicadorVentasClientesPjePG: 0,
      indicadorVentasClientesGnm: 0,
      indicadorVentasClientesPjeGnm: 0,
      indicadorVentasClientesOtros: 0,

      indicadorVentasClientesPjeObjetivo: parseInt(0),
      indicadorVentasClientesPjeActual: 0,
      indicadorVentasClientesColor: [{ offset: 0, color: '#E46651'}, { offset: 100, color: '#E46651' }],
      // indicadorVentasClientesColor: [{ offset: 0, color: '#E46651'}, { offset: 100, color: '#41B883' }],
      indicadorVentasClientesMin: 0,
      indicadorVentasClientesMax: 100,
    }
  },
  methods: {
    getIndicador() {
      let dispatch = 'resultadosVentas/getIndicadorVentasMixClientes';
      let getter = 'resultadosVentas/indicadorVentasMixClientes';

      if ( (/true/i).test(this.totalNegocio)) {
        dispatch = 'resultadosVentas/getIndicadorVentasTotalMixClientes';
        getter = 'resultadosVentas/indicadorVentasTotalMixClientes';
      }

      this.$store.dispatch(dispatch)
        .then(() => {
          let indicador = this.$store.getters[getter];

          let pjeVentasPGGnm = 0;
          let pjeVentasOtros = 0;
          let pjeVentasPG = 0;
          let pjeVentasGnm = 0;
          let montoVentas = 0;

          if (indicador) {
            if (indicador.pjeActual) {
              pjeVentasPGGnm = indicador.pjeActual;
              montoVentas = parseFloat(indicador.montoBasePG) 
                + parseFloat(indicador.montoBaseGnm) 
                + parseFloat(indicador.montoBaseOtros); 
            }
          }
          if (montoVentas != 0) {
            pjeVentasOtros = parseFloat(100) - pjeVentasPGGnm;
            pjeVentasOtros = +(Math.round(pjeVentasOtros + "e+2")  + "e-2")

            pjeVentasPG = parseFloat(indicador.montoBasePG) / montoVentas * parseFloat(100);
            // pjeVentasPG = +(Math.round(pjeVentasPG + "e+2")  + "e-2")
            pjeVentasGnm = parseFloat(indicador.montoBaseGnm) / montoVentas * parseFloat(100);
            // pjeVentasGnm = +(Math.round(pjeVentasGnm + "e+2")  + "e-2")
          }

          this.indicadorVentasClientesData = [pjeVentasPGGnm, pjeVentasOtros];

          this.indicadorVentasClientesPjeObjetivo = parseInt(indicador.pjeObjetivo);
          this.indicadorVentasClientesPjeActual = pjeVentasOtros;
          this.indicadorVentasClientesDescripcion = indicador.indicadorPeriodo? indicador.indicadorPeriodo.trim() : '';
          // this.indicadorVentasClientesDescripcion = indicador.descripcion? indicador.descripcion.trim() : '';
          this.indicadorVentasClientesPG = parseFloat(indicador.montoBasePG);
          this.indicadorVentasClientesPjePG = parseFloat(pjeVentasPG);
          this.indicadorVentasClientesGnm = parseFloat(indicador.montoBaseGnm);
          this.indicadorVentasClientesPjeGnm = parseFloat(pjeVentasGnm);
          this.indicadorVentasClientesOtros = parseFloat(indicador.montoBaseOtros);

          // if (parseFloat(pjeVentasOtros) >= parseFloat(indicador.pjeObjetivo) * parseFloat(1.1)) {
          //   this.indicadorVentasClientesColor = [{ offset: 0, color: this.rosa }, { offset: 100, color: this.rosa }];
          // } else 
          if (parseFloat(pjeVentasOtros) >= parseFloat(indicador.pjeObjetivo)) {
            this.indicadorVentasClientesColor = [{ offset: 0, color: this.verde}, { offset: 100, color: this.verde } ];
          } else if (parseFloat(pjeVentasOtros) >= (parseFloat(indicador.pjeObjetivo) / parseFloat(2))) {
            this.indicadorVentasClientesColor = [{ offset: 0, color: this.amarillo}, { offset: 100, color: this.amarillo } ];
          }
        })
        .finally(() => this.key++);
    },
  }
}
</script>

<style>
</style>


